import React from 'react'

import { DueOut } from '../../assets/ts/data/dueout/dueout'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import { handleScroll } from '../../assets/ts/general/general'
import NO_RESULTS from '../../utils/constants/no-results'
import ExportToCSVButton from '../buttons/export-to-csv-btn'
import CustomerDashboardDueOutsTableHead from './customer-dashboard-dueouts-table-head'
import CustomerDashboardDueOutsTableRow from './customer-dashboard-dueouts-table-row'
import './table.css'

type Props = {
  count: string
  countNumber : number
  dueOuts: DueOut[]
  getAllSelectedRecords: () => Promise<DueOut[]>
  onBottomScrollReached?: () => void
  onTopScrollReached?: () => void
  title: string
}

export const CustomerDashboardDueoutsTable = ({
  count,
  countNumber,
  dueOuts,
  getAllSelectedRecords,
  onBottomScrollReached,
  onTopScrollReached,
  title,
}: Props) => {
  return (
    <>
      <div className='d-flex py-2 border-bottom1 align-items-center tableheader'>
        <h2
          aria-describedby='tableheading'
          className='m-0 p-0 align-items-sm-center poppins-semibold font-13 text-uppercase'
          id='tableheading'
          tabIndex={0}
        >
          {defaultToEmptyString(title)}{' '}
          <span className='badge border-radius3 px-2 py-1 whitetext poppins-semibold bgcolor-primary'>
            {defaultToEmptyString(count)}
          </span>
        </h2> 
       { countNumber > 0 && <ExportToCSVButton
          fetchDataFunc={getAllSelectedRecords}
          pageType='CustomerDashboard/Dueouts'
        />}
      </div>

      <div
        className='w-100 overflow-auto px-1 inquiriestable'
        onScroll={(e) =>
          handleScroll(e, onTopScrollReached, onBottomScrollReached)
        }
      >
        <table className='table-borderless table-dis w-100 sticky-top second-column last-column table-rowgap'>
          <CustomerDashboardDueOutsTableHead />
          <tbody>
            {dueOuts.map((d) => (
              <CustomerDashboardDueOutsTableRow dueout={d} key={d.DueOutGUID} />
            ))}
          </tbody>
        </table>
        {dueOuts.length < 1 && <NO_RESULTS/>}
      </div>
    </>
  )
}
export default CustomerDashboardDueoutsTable
